export default {
  title: "SCRM"
};
